const capitalizeFirstLetter = (v) => v.length ? `${v[0].toUpperCase()}${v.slice(1)}` : '';
export const capitalize = (v) => {
    if (!v)
        return '';
    return v
        .split(' ')
        .map((word, i) => {
        if (['the', 'of', 'is', 'and'].some(exception => exception.toLowerCase() === word.toLowerCase() && i !== 0 // Capitalize first word with no exceptions
        )) {
            return word.toLowerCase();
        }
        return capitalizeFirstLetter(word);
    })
        .join(' ');
};
export const formatUsername = (u) => {
    if (!u)
        return '';
    return u.toLowerCase().replace(/[^0-9a-z_]/g, '');
};
export const formatEmail = (e) => e ? e.toLowerCase().replace(/ /g, '') : '';
/**
 * Tests if string is valid Postgresql UUID
 */
export const isValidUUID = (id) => {
    if (!id)
        return false; // Handle undefined or empty cases safely
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    const test = uuidRegex.test(id);
    return test;
};
/**
  Formats an array of strings into a comma separated list with the & between last.
  - length 1 -> `string`
  - length 2 -> `string & string`
  - length 3+ -> `string, string & string`
*/
export function formatStringListWithCommaAnd(strings) {
    switch (strings.length) {
        case 0:
            return '';
        case 1:
            return strings[0];
        case 2:
            return `${strings[0]} & ${strings[1]}`;
        // 3+
        case 3:
        default:
            return strings.slice(0, -1).join(', ') + ' & ' + strings[strings.length - 1];
    }
}
